import React, { FC } from "react";
import { Link } from "react-router-dom";
import { KTSVG, toAbsoluteUrl } from "../../../_metronic/helpers";
import { FormattedMessage } from "react-intl";

export const QuickLinks: FC = () => (
    <div className="quickLinks" data-kt-menu="true">
        <div
            className="title"
            style={{ backgroundImage: `url('${toAbsoluteUrl("/media/misc/quicklinks_bg.jpg")}')` }}
        >
            <h3 className="text-white fw-bold mb-3">
                <FormattedMessage id="layout.quicklinks.title" />
            </h3>
        </div>

        <div className="row g-0">
            <div className="col-6 border-bottom">
                <Link to="space-management/users/summary">
                    <KTSVG path="/media/icons/duotune/communication/com014.svg" />
                    <span className="fs-7 text-gray-400">
                        <FormattedMessage id="layout.quicklinks.manage" />
                    </span>
                    <span className="fs-5 fw-bold mb-0">
                        <FormattedMessage id="layout.quicklinks.users" />
                    </span>
                </Link>
            </div>

            <div className="col-6">
                <Link to="space-management/api-credentials">
                    <KTSVG path="/media/icons/duotune/coding/cod009.svg" />
                    <span className="fs-7 text-gray-400">
                        <FormattedMessage id="layout.quicklinks.configure" />
                    </span>
                    <span className="fs-5 fw-bold mb-0">
                        <FormattedMessage id="layout.quicklinks.api" />
                    </span>
                </Link>
            </div>

            <div className="col-6 border-bottom">
                <Link to="space-management/documentation">
                    <span className="">
                        <KTSVG path="/media/icons/duotune/abstract/abs043.svg" />
                    </span>
                    <span className="fs-7 text-gray-400">
                        <FormattedMessage id="layout.quicklinks.read" />
                    </span>
                    <span className="fs-5 fw-bold mb-0">
                        <FormattedMessage id="layout.quicklinks.docs" />
                    </span>
                </Link>
            </div>

            <div className="col-6">
                <Link to="space-management/thematics">
                    <KTSVG path="/media/icons/duotune/technology/teh008.svg" />
                    <span className="fs-7 text-gray-400">
                        <FormattedMessage id="layout.quicklinks.organise" />
                    </span>
                    <span className="fs-5 fw-bold mb-0">
                        <FormattedMessage id="layout.quicklinks.thematics" />
                    </span>
                </Link>
            </div>
        </div>
    </div>
);
